// extracted by mini-css-extract-plugin
export default {"section-body":"spOPuC0Zzci1h434Xjg6","section-title":"SB_eycnPZV7DUPfNAM7v"};